// extracted by mini-css-extract-plugin
export default {"primary":"#0e6bb0","darkblue":"#1366a8","success":"#0b9a10","info":"#9c27b0","danger":"#e51c23","warning":"#ff9800","dark":"#222","secondary":"#fff","ligth":"#efefef"};